export enum CredExpInfoActionTypes {
    API_RESPONSE_SUCCESS = '@@credExpInfo/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@credExpInfo/API_RESPONSE_ERROR',

    ADD_CRED_EXP_INFO = '@@credExpInfo/ADD_CRED_EXP_INFO',
    EDIT_CRED_EXP_INFO = '@@credExpInfo/EDIT_CRED_EXP_INFO',
    GET_CRED_EXP_INFOS = '@@credExpInfo/GET_CRED_EXP_INFOS',
    GET_CRED_EXP_INFO = '@@credExpInfo/GET_CRED_EXP_INFO',
    RESET = '@@credExpInfo/RESET',
    RESET_SUCCESS = '@@credExpInfo/RESET_SUCCESS',
    RESET_ERROR = '@@credExpInfo/RESET_ERROR',
}
